/* 🤖 this file was generated by svg-to-ts */
export const matIconScreenLockLandscape: {
  name: 'screen-lock-landscape';
  data: string;
} = {
  name: 'screen-lock-landscape',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10zm-9-1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1a2 2 0 1 0-4 0v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2v1h-2.4v-1z"/></svg>`
};
